import { render, staticRenderFns } from "./CashComment.vue?vue&type=template&id=489a64c8&"
import script from "./CashComment.vue?vue&type=script&lang=js&"
export * from "./CashComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports